import {Component, Input } from '@angular/core';
import { PhotoData } from '../../../globals/store/user.data';
import { CommonModule } from '@angular/common';
import { InitialsPipe } from '../services/pipes/initials.pipe';

@Component({
    selector: 'photo',
    imports: [CommonModule, InitialsPipe],
    template: `
<div class="photo_content" [ngClass]="{reverse:reverse, logo: logo}">
  <div *ngIf="data?.photoURL" [ngClass]="{logo: logo}" class="profile_image s{{size}} {{theme}}" [ngStyle]="{'background-image':'url('+data.photoURL+')'}"></div>
  <div *ngIf="data && !data.photoURL"  class="initials s{{size}} {{theme}}">{{ (!data?.firstName && !data?.lastName ? (data.title || '') : data.firstName +' '+ data.lastName) | initials }}</div>
</div>
`,
    styles: [`
.photo_content { padding:0; margin:0 10px 0 0; border-radius:200px; overflow: hidden; }
.photo_content.reverse { padding:0; margin:0 0 0 10px; }
/*.photo_content img { display: block; }*/
.photo_content.logo { border-radius: 0px; }
.photo_content .initials { border-radius:200px; color: rgba(0,0,0,0.4); background: rgba(0,67,112,0.07); text-align: center; }
.photo_content .initials.s16 { width:16px; height:16px; line-height:16px; font-size: 10px;}
.photo_content .initials.s18 { width:18px; height:18px; line-height:18px; font-size: 10px;}
.photo_content .initials.s24 { width:24px; height:24px; line-height:24px; font-size: 10px;}
.photo_content .initials.s36 { width:36px; height:36px; line-height:36px; font-size:16px; }
.photo_content .initials.s60 { width:60px; height:60px; line-height:60px; font-size:20px; }
/*.photo_content img.s80 { max-width:80px; max-height:80px; }*/
.photo_content .initials.s80 { width:80px; height:80px; line-height:80px; font-size:24px; }
.photo_content .initials.s120 { width:120px; height:120px; line-height:120px; font-size:32px; }
.photo_content .initials.on-dark { color: #41474F; background: #ffffff; }
.photo_content .profile_image { background: rgba(0,67,112,0.07) center center; background-size: cover; }
.photo_content .profile_image.logo { background: var(--pagebackground) center center; background-size: contain; background-repeat: no-repeat; }
.photo_content .profile_image.s16 { width:16px; height:16px; }
.photo_content .profile_image.s18 { width:18px; height:18px; }
.photo_content .profile_image.s24 { width:24px; height:24px; }
.photo_content .profile_image.s36 { width:36px; height:36px; }
.photo_content .profile_image.s60 { width:60px; height:60px; }
.photo_content .profile_image.s80 { width:80px; height:80px; }
.photo_content .profile_image.s120 { width:120px; height:120px; }
.photo_content .profile_image.s120.logo { width: 160px; height: 120px; }
    `],
    standalone: true,
})
export class PhotoComponent  {
    @Input() data: PhotoData = {};
    @Input() initials
    @Input() size = 24;
    @Input() theme = '';
    @Input() reverse = false;
    @Input() logo = false;
}

